import * as React from 'react'
import { authService, homeService } from '../../services'
import { toast, ToastContainer } from 'react-toastify'
import { SignIn } from './modules/Auth/containers'
import { Register } from './modules/Register/containers'
import { connect } from 'react-redux'
import ResponsiveHeader from './containers/ResponsiveHeader'
import { FloatButton, Footer } from './components'
import { Redirect, Route, Switch } from 'react-router'
import { AuthRoute } from '../../core'
import RollItemStore from './modules/RollItemStore/RollItemStore'
import User from './modules/User/User'
import { PageType } from '../../enums'
import Admin from './modules/Admin/Admin'
import ConfirmRegister from '../Auth/containers/ConfirmRegister'
import ExchangeStore from './modules/ExchangeStore/ExchangeStore'
import TipStore from './modules/Tip/TipStore'

type HomeRollProps = {
  loggedIn: boolean
  userInfo?: IUser,
}

type HomeRollState = {
  showSignIn: boolean,
  showRegister: boolean
}

class HomeRoll extends React.Component<HomeRollProps, HomeRollState> {
  state = {
    showSignIn: false,
    showRegister: false
  }

  componentWillMount(): void {
    homeService.getAppState()
  }

  handleSignOut = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    authService.signout()
      .then(() => toast.success('Logout successfully!'))
      .catch(error => toast.error(error.message))
  }

  handleClickSignIn = (event: React.FormEvent<any>) => {
    this.setState({ showSignIn: true, showRegister: false })
  }

  handleRegister = (event: React.FormEvent<any>) => {
    this.setState({ showRegister: true, showSignIn: false })
  }

  render() {
    const { loggedIn, userInfo } = this.props
    const { showSignIn, showRegister } = this.state

    return (
      <div>
        <ResponsiveHeader
          isLoggedIn={loggedIn}
          userInfo={userInfo}
          handleRegister={this.handleRegister}
          handleSignIn={this.handleClickSignIn}
          handleSignOut={this.handleSignOut}
        >
          <Switch>
            <Route path="/pick" component={RollItemStore} />
            <Route path="/tip" component={TipStore} />
            <AuthRoute path={'/user'} component={User} pageType={PageType.USER} />
            <AuthRoute path={'/admin'} component={Admin} pageType={PageType.ADMIN} />
            <Route path="/verify/:code/" component={ConfirmRegister} />
            <Route path="/exchange-coin" component={ExchangeStore} />
            <Redirect to="/pick" />
          </Switch>
        </ResponsiveHeader>
        <Footer />
        <FloatButton />
        <SignIn isShow={showSignIn && !loggedIn} />
        <Register isShow={showRegister && !loggedIn} />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={true}
          pauseOnHover={true}
        />
      </div>
    )
  }

}

const mapStateToProps = (state: IAppState, ownProps: any) => ({
  ...ownProps,
  loggedIn: state.loggedIn,
  userInfo: state.root.userInfo,
})

export default connect(mapStateToProps)(HomeRoll)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/HomeRoll.tsx